import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.js";
import Wave from '../utility-components/wave.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Contact Me`}</h1>
    <p>{`You can reach me at `}<a parentName="p" {...{
        "href": "mailto:somethingSomething@gmail.com."
      }}>{`somethingSomething@gmail.com.`}</a>{` Send me a message at `}<a parentName="p" {...{
        "href": "mailto:somethingSomething@gmail.com"
      }}>{`somethingSomething@gmail.com`}</a></p>
    <h2>{`Click a wave button to wave at the creator of this blog`}</h2>
    <Wave mdxType="Wave" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      